import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
// import dummyData from '../data.json'; // Import JSON

export default function QueueChart() {
  const [queueData, setQueueData] = useState([]);
  const threshold = 6; // Threshold value

  useEffect(() => {
    // setQueueData(dummyData.queueCount || []); // Load data safely
    setQueueData([]);
  }, []);

  const times = queueData.map((item) => item.time);

  const chartOptions = {
    chart: {
      type: 'area',
      height: 400,
      toolbar: { show: false }
    },
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    markers: {
      size: 4,
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: { size: 6 }
    },
    xaxis: {
      categories: times,
      title: { text: 'Time', style: { fontSize: '14px' } }
    },
    yaxis: {
      title: { text: 'Queue Count', style: { fontSize: '14px' } },
      min: 0,
      max: 16
    },
    annotations: {
      yaxis: [
        {
          y: threshold,
          borderColor: '#FF0000',
          strokeDashArray: 5,
          label: {
            borderColor: '#FF0000',
            style: {
              color: 'white',
              background: '#FF0000',
              fontSize: '12px'
            },
            text: `Threshold: ${threshold}`
          }
        }
      ]
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '14px'
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.3,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 100]
      }
    },
    colors: ['#A8E4B1', '#44BE54', '#247331'] // Indigo, Sky Blue, Periwinkle
  };

  const chartSeries = [
    { name: 'Counter 1', data: queueData.map((item) => item.counter1) },
    { name: 'Counter 2', data: queueData.map((item) => item.counter2) },
    { name: 'Counter 3', data: queueData.map((item) => item.counter3) }
  ];

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px' }}>
      <Chart options={chartOptions} series={chartSeries} type="area" height={400} width="100%" />
    </div>
  );
}
